import { render } from "./LayerMailPopup.vue?vue&type=template&id=4ab9a1bb&scoped=true"
import script from "./LayerMailPopup.vue?vue&type=script&lang=js"
export * from "./LayerMailPopup.vue?vue&type=script&lang=js"

import "./LayerMailPopup.vue?vue&type=style&index=0&id=4ab9a1bb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab9a1bb"]])

export default __exports__